import { ApexOptions } from "apexcharts";
import { Primary, Secondary } from "../../../Constants/Constants";

export const OptionsSalesSummary: ApexOptions = {
  series: [
    {
      name: "Activity",
      data: [42, 44, 55, 66, 55, 86, 52, 44, 44, 66, 55, 86, 52, 44, 44],
    },
  ],
  chart: {
    height: 158,
    type: "bar",
    toolbar: {
      show: false,
    },
    sparkline: {
      enabled: true,
    },
  },
  plotOptions: {
    bar: {
      distributed: true,
      borderRadius: 3,
      columnWidth: "40%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
  },
  legend: {
    show: false,
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  colors: ["#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", Primary, "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff", "#e9f2ff"],
};

export const OfflineChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    },
  ],
  chart: {
    type: "area",
    offsetY: 30,
    height: 198,
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 2,
      color: Secondary,
      opacity: 0.2,
    },
  },
  colors: [Secondary],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.1,
      stops: [0, 90, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  stroke: {
    curve: "straight",
    width: 2,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 12,
        fillColor: Secondary,
        strokeColor: "#fff",
        size: 5,
        shape: "circle",
      },
    ],
  },
};

export const RevenueChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [15, 14, 11, 20, 10, 15, 11],
    },
  ],
  chart: {
    type: "area",
    height: 180,
    offsetY: 10,
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 5,
      left: 0,
      blur: 2,
      color: "#58b232",
      opacity: 0.2,
    },
  },
  colors: ["#58b232"],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.6,
      opacityTo: 0.2,
      stops: [0, 100, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 3,
        fillColor: "#58b232",
        strokeColor: "#fff",
        size: 6,
        shape: "circle",
      },
    ],
  },
};

export const VisitorChart: ApexOptions = {
  series: [
    {
      name: "Active",
      data: [18, 50, 65, 18, 28, 70, 15, 35],
    },
    {
      name: "Bounce",
      data: [35, 70, 30, 60, 25, 45, 50, 50],
    },
  ],
  chart: {
    type: "bar",
    height: 240,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 6,
    colors: ["transparent"],
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: [Secondary, Primary],
  xaxis: {
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon"],
    tickAmount: 4,
    tickPlacement: "between",
    labels: {
      style: {
        fontFamily: "Poppins, sans-serif",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 5,
    labels: {
      style: {
        fontFamily: "Poppins, sans-serif",
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    labels: {
      colors: "var(--chart-text-color)",
    },
    itemMargin: {
      horizontal: 20,
    },
  },
  responsive: [
    {
      breakpoint: 1366,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "80%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "60%",
          },
        },
        grid: {
          padding: {
            right: 5,
          },
        },
      },
    },
  ],
};

export const GeneralLearning: ApexOptions = {
  series: [
    {
      name: "growth",
      type: "line",
      data: [25, 30, 43, 25, 38, 25, 33, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 30, 41, 25, 36, 25, 31, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 29, 37, 25, 34, 25, 29, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 28, 34, 25, 32, 25, 28, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 27, 30, 25, 28, 25, 27, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 26, 24, 25, 24, 25, 24, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 26, 20, 25, 21, 25, 23, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 24, 16, 25, 18, 25, 22, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 23, 12, 25, 15, 25, 21, 25],
    },
    {
      name: "growth",
      type: "line",
      data: [25, 23, 10, 25, 13, 25, 19, 25],
    },
    {
      name: "growth",
      type: "area",
      data: [25, 28, 37, 25, 33, 25, 27, 25],
    },
  ],
  chart: {
    height: 276,
    type: "line",
    toolbar: {
      show: false,
    },
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: [Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary, Secondary, Primary],
  stroke: {
    width: 1.5,
    curve: "smooth",
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 0,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
      {
        seriesIndex: 1,
        dataPointIndex: 5,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
      {
        seriesIndex: 2,
        dataPointIndex: 3,
        fillColor: Primary,
        strokeColor: "#fff",
        size: 6,
      },
    ],
  },
  tooltip: {
    shared: false,
    intersect: false,
  },
  xaxis: {
    type: "category",
    categories: ["Sep 5", "Sep 8", "Sep 12", "Sep 16", "Sep 18", "Sep 17", "Sep 23", "Sep 26"],
    tickAmount: 12,
    labels: {
      style: {
        colors: "var(--chart-text-color)",
        fontSize: "12px",
        fontFamily: "Rubik, sans-serif",
        fontWeight: 400,
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  fill: {
    type: ["solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "solid", "gradient"],
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 0.5,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 80, 100],
    },
  },
  yaxis: {
    min: 0,
    max: 50,
    tickAmount: 5,
    labels: {
      style: {
        colors: "var(--chart-text-color)",
        fontSize: "12px",
        fontFamily: "Rubik, sans-serif",
        fontWeight: 400,
      },
    },
  },
  legend: {
    show: false,
  },
};

export const Radial1: ApexOptions = {
  series: [78],
  chart: {
    type: "radialBar",
  },
  colors: [Primary],
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
        },
      },
    },
  },
};

export const Radial2: ApexOptions = {
  series: [70],
  chart: {
    type: "radialBar",
  },
  colors: [Secondary],
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
        },
      },
    },
  },
};

export const Radial3: ApexOptions = {
  series: [50],
  chart: {
    type: "radialBar",
  },
  colors: ["#58b232"],
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
        },
      },
    },
  },
};

export const Radial4: ApexOptions = {
  series: [80],
  chart: {
    type: "radialBar",
  },
  colors: ["#ffb829"],
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
        },
      },
    },
  },
};

export const GeneralGrowth: ApexOptions = {
  series: [
    {
      name: "TEAM A",
      type: "column",
      data: [220, null, 250, null, 210, null, 210, null, 270, null, 220, null, 250, null, 260, null, 210, null, 230],
    },
    {
      name: "TEAM B",
      type: "area",
      data: [210, 170, 240, 160, 200, 170, 200, 150, 260, 170, 210, 170, 240, 160, 250, 140, 200, 140, 220, 220],
    },
  ],
  chart: {
    height: 310,
    type: "area",
    stacked: false,
    toolbar: {
      show: false,
    },
  },
  stroke: {
    width: [0, 2, 5],
    curve: "stepline",
  },
  plotOptions: {
    bar: {
      columnWidth: "35px",
    },
  },
  colors: ["#bebebe", "#2A5699"],
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.5,
      opacityTo: 0.1,
      stops: [0, 90, 100],
    },
  },
  grid: {
    show: true,
    yaxis: {
      lines: {
        show: true,
      },
    },
  },
  xaxis: {
    categories: ["Jan", "", "Feb", "", "Mar", "", "Apr", "", "May", "", "Jun", "", "Jul", "", "Aug", "", "Sep", "", "Oct", ""],
    labels: {
      style: {
        fontFamily: "Outfit, sans-serif",
        fontWeight: 500,
        colors: "#8D8D8D",
      },
    },
    axisBorder: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  yaxis: {
    labels: {
      style: {
        fontFamily: "Outfit, sans-serif",
        fontWeight: 500,
        colors: "#8D8D8D",
      },
    },
  },
  legend: {
    show: false,
  },
  tooltip: {
    custom: ({ series, seriesIndex, dataPointIndex }) => `
      <div class="apex-tooltip p-2">
        <span>
          <span class="bg-primary"></span>
          Project Created
          <h3>$${series[seriesIndex][dataPointIndex]}</h3>
        </span>
      </div>
    `,
  },
};

export const OptionsRevenueOrder: ApexOptions = {
  series: [
    {
      name: "Earning",
      type: "line",
      data: [330, 60, 370, 240, 250, 70, 280, 60, 185, 60],
    },
    {
      name: "Order",
      type: "line",
      data: [70, 330, 60, 200, 100, 250, 100, 350, 110, 300],
    },
  ],
  chart: {
    height: 274,
    type: "line",
    stacked: false,
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 2,
      left: 0,
      blur: 4,
      color: "#000",
      opacity: 0.08,
    },
  },
  stroke: {
    width: [2, 2, 2],
    curve: "smooth",
  },
  grid: {
    show: false,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: "20%",
    },
  },
  colors: ["#FF5733", "#33FF57"],
  fill: {
    opacity: 1,
    type: "solid",
  },
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
  xaxis: {
    type: "category",
    tickAmount: 8,
    tickPlacement: "between",
    tooltip: {
      enabled: false,
    },
    axisBorder: {
      color: "var(--chart-border)",
    },
    axisTicks: {
      show: false,
    },
  },

  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 3,
        fillColor: "#FF5733",
        strokeColor: "#FFFFFF",
        size: 6,
      },
    ],
    hover: {
      size: 6,
      sizeOffset: 0,
    },
  },

  legend: {
    show: false,
  },
  yaxis: {
    min: 0,
    tickAmount: 4,
    labels: {
      formatter: (val) => (val !== undefined ? val + "K" : ""),
    },
  },
  tooltip: {
    enabled: false,
  },
};

export const OnlineSalesCardData = [
  { icon: "basket", color: "primary", arrowChart: "arrow-chart-up", arrowColor: "success", title: "Online Sales", endValue: 36256, text: "+5.4%", chart: OptionsSalesSummary },
  { icon: "delivery", color: "secondary", arrowChart: "arrow-chart", arrowColor: "danger", title: "Offline Sales", endValue: 12341, text: "-4.7%", chart: OfflineChart, chartClass: "offline-chart" },
  { icon: "increased", color: "success", arrowChart: "arrow-chart-up", arrowColor: "success", title: "Total Profit", endValue: 85478, text: "+8.2%", chart: RevenueChart, chartClass: "revenue" },
];

export const OrderOverviewData = [
  { value: 40, title: "Online Order", color: "primary" },
  { value: 60, title: "Offline Order", color: "secondary" },
  { value: 20, title: "Cash On Delivery", color: "success" },
  { value: 50, title: "Return Order", color: "warning" },
];

export const TransactionHistoryData = [
  { icon: "send", color: "primary", title: "Receipt from Wallet", date: "Mar 21,2024, 4:45pm", stash: "Completed", price: "+ $248.00" },
  { icon: "work", color: "secondary", title: "Process refund to", date: "Feb 20,2024, 2:10pm", stash: "Pending", price: "+ $548.00" },
  { icon: "graph", color: "success", title: "Sending to Citizen", date: "Jun 17,2024, 12:45pm", stash: "Verified", price: "+ $953.00" },
  { icon: "payment-bookmark", color: "warning", title: "Payment From #425", date: "Oct 30,2024, 1:31pm", stash: "Rejected", price: "+ $349.00" },
];

export const SocialWidgetData = [
  { title: "Facebook", percentage: "+22.9%", color: "success", text: "12,098", type: "Likes", chart: Radial1 },
  { title: "Instagram", percentage: "-27.4%", color: "danger", text: "15,080", type: "Followers", chart: Radial2 },
  { title: "X (Twitter)", percentage: "+76.10%", color: "success", text: "12,564", type: "Followers", chart: Radial3 },
  { title: "Youtube", percentage: "+62.08%", color: "success", text: "12,564", type: "Followers", chart: Radial4 },
];
